const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  906: {
    path: "/systemConfig",
    name: "systemConfig",
    meta: {
      title: "系统设置",
      authId: "906",
      parentId: "1",
      cache: false
    }
  },
  90601: {
    path: "/personalInfo",
    name: "personalInfo",
    meta: {
      title: "个人信息",
      authId: "90601",
      parentId: "906",
      cache: false
    },
    component: _import("systemConfig/personalInfo")
  },
  90603: {
    path: "/merchantManage",
    name: "merchantManage",
    meta: {
      title: "商户管理",
      authId: "90603",
      parentId: "906",
      cache: false
    },
    auth: [
      {
        authId: "9060302",
        parentId: "90603",
        label: "关联导流方",
        category: "Button",
        type: "primary",
        handle: "handleRelate"
      },
      {
        authId: "9060303",
        parentId: "90603",
        label: "查看详情",
        handle: "handleViewDetail",
        addRoutePath: [
          {
            authId: "90614",
            name: "查看详情页面",
            parentId: "90603"
          }
        ]
      },
      {
        authId: "9060301",
        parentId: "90603",
        label: "财务",
        handle: "handleDetail",
        addRoutePath: [
          {
            authId: "90604",
            name: "财务详情",
            parentId: "90603"
          }
        ]
      },
      {
        authId: "9060306",
        parentId: "90603",
        label: "品牌设置",
        handle: "brandSettings"
      },

      {
        authId: "9060304",
        parentId: "90603",
        label: "历史记录",
        handle: "handleRecord",
        addRoutePath: [
          {
            authId: "90615",
            name: "历史记录页面",
            parentId: "90603"
          }
        ]
      },
      // {
      //   authId: "9060307",
      //   parentId: "90603",
      //   label: "商户关联",
      //   category: "Button",
      //   type: "primary",
      //   handle: "handleMerchantRelate"
      // },
      {
        authId: "9060308",
        parentId: "90603",
        label: "对账",
        // category: "Button",
        // type: "primary",
        handle: "handleCheck",
        addRoutePath: [
          {
            authId: "90613",
            name: "对账页面",
            parentId: "90603"
          }
        ]
      },
      {
        authId: "9060309",
        parentId: "90603",
        label: "质保卡配置",
        handle: "setWarrantyCard"
      },
      {
        authId: "90603010",
        parentId: "90603",
        label: "下级商户配置",
        handle: "setSubordinateMerchant"
      },
      {
        authId: "9060305",
        parentId: "90603",
        label: "删除",
        handle: "handleDelete"
      },
      {
        authId: "90603011",
        parentId: "90603",
        label: "收款码",
        handle: "collectionQRcode"
      },
      {
        authId: "90603012",
        parentId: "90603",
        label: "配置",
        handle: "handleSet",
        addRoutePath: [
          {
            authId: "90603013",
            name: "配置页面",
            parentId: "90603012"
          }
        ]
      },
      {
        authId: "90603014",
        parentId: "90603",
        label: "商户上架",
        category: "Button",
        type: "primary",
        handle: "handleMerchantGrounding",
        addRoutePath: [
          {
            authId: "90603015",
            name: "商户上架",
            parentId: "90603"
          }
        ]
      },
      {
        authId: "90603016",
        parentId: "90603",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "90603017",
        parentId: "90603",
        label: "编辑",
        handle: "handleEditMerchantGrounding",
        addRoutePath: [
          {
            authId: "90603015",
            name: "商户上架",
            parentId: "90603"
          }
        ]
      }
    ],
    component: _import("systemConfig/merchant/merchantManage")
  },
  90603015: {
    path: "/merchantGrounding",
    name: "merchantGrounding",
    meta: {
      title: "商户上架",
      authId: "90603015",
      parentId: "90603",
      cache: false,
      activePath: "/merchantManage"
    },
    component: _import("systemConfig/merchant/merchantGrounding")
  },
  90604: {
    path: "/merchantDetail",
    name: "merchantDetail",
    meta: {
      title: "财务详情",
      authId: "90604",
      parentId: "90603",
      cache: false,
      activePath: "/merchantManage"
    },
    component: _import("systemConfig/merchant/financialRules/index")
  },
  90603013: {
    path: "/setDetail",
    name: "setDetail",
    meta: {
      title: "配置详情",
      authId: "90603013",
      parentId: "90603",
      cache: false,
      activePath: "/merchantManage"
    },
    component: _import("systemConfig/merchant/setDetail")
  },
  90605: {
    path: "/serviceManage",
    name: "serviceManage",
    meta: {
      title: "服务商管理",
      authId: "90605",
      parentId: "906",
      cache: false
    },
    auth: [
      {
        authId: "9060501",
        parentId: "90605",
        label: "关联服务商",
        category: "Button",
        type: "primary",
        handle: "handleRelate"
      },
      {
        authId: "9060502",
        parentId: "90605",
        label: "删除",
        handle: "handleDelete"
      },
      {
        authId: "9060503",
        parentId: "90605",
        label: "编辑",
        handle: "handleEdit",
        addRoutePath: [
          {
            authId: "9060504",
            name: "编辑页面",
            parentId: "90605"
          }
        ]
      }
    ],
    component: _import("systemConfig/serviceManage/serviceManage")
  },
  9060504: {
    path: "/editService",
    name: "editService",
    meta: {
      title: "编辑服务商",
      authId: "9060504",
      parentId: "90605",
      cache: false,
      activePath: "/serviceManage"
    },
    component: _import("systemConfig/serviceManage/editService")
  },
  90608: {
    path: "/yqStoreManage",
    name: "yqStoreManage",
    meta: {
      title: "园区店管理",
      authId: "90608",
      parentId: "906",
      cache: false
    },
    auth: [
      {
        authId: "9060801",
        parentId: "90608",
        label: "编辑",
        handle: "handleDetail"
      },
      {
        authId: "9060802",
        parentId: "90608",
        label: "收款二维码",
        handle: "collectionQRcode"
      },
      {
        authId: "9060803",
        parentId: "90608",
        label: "订单质保二维码配置",
        handle: "handleQrcode"
      },
      {
        authId: "9060804",
        parentId: "90608",
        label: "场景入口",
        handle: "handleSceneEntry"
      }
    ],
    component: _import("systemConfig/yqStoreManage/yqStoreManage")
  },
  90609: {
    path: "/yqStoreDetail",
    name: "yqStoreDetail",
    meta: {
      title: "园区店配置",
      authId: "90609",
      parentId: "90608",
      cache: false,
      activePath: "/yqStoreManage"
    },
    component: _import("systemConfig/yqStoreConfig")
  },

  90610: {
    path: "/accountList_new",
    name: "accountList_new",
    meta: {
      title: "新虚拟对公账户",
      authId: "90610",
      parentId: "906",
      cache: false
    },
    auth: [
      {
        authId: "9061001",
        parentId: "90610",
        label: "申请虚拟对公账户",
        handle: "handleApply",
        ruleObj: {
          attr: "accountStatus",
          rule: {
            1: "申请虚拟对公账户",
            2: "申请虚拟对公账户",
            3: "账户详情",
            4: "申请虚拟对公账户"
          },
          disabledStatusList: [2]
        },
        addRoutePath: [
          {
            authId: "90611",
            name: "申请虚拟账户成本",
            parentId: "90610"
          }
        ]
      },
      {
        authId: "9061003",
        parentId: "90610",
        label: "同步",
        category: "Button",
        type: "primary",
        handle: "synchronization"
      },
      {
        authId: "9061004",
        parentId: "90610",
        label: "商户关联",
        handle: "handleCustomerAssociation"
      },
      {
        authId: "9061005",
        parentId: "90610",
        label: "账户详情",
        handle: "handleDetail"
      },
      {
        authId: "9061006",
        parentId: "90610",
        label: "操作记录",
        handle: "handleOperationRecords"
      },
      {
        authId: "9061007",
        parentId: "90610",
        label: "账户详情",
        handle: "handleApply"
      },
      {
        authId: "9061008",
        parentId: "90610",
        label: "修改到账模式",
        handle: "handleEditAccountMode"
      }
    ],
    component: _import("systemConfig/accountNew/accountList_newIndex")
  },
  90611: {
    path: "/applyAccount_new",
    name: "applyAccount_new",
    meta: {
      title: "申请虚拟账户成本",
      authId: "90611",
      parentId: "90610",
      cache: false,
      activePath: "/accountList_new"
    },
    component: _import("systemConfig/accountNew/applyAccount")
  },
  90612: {
    path: "/sceneCategoryManage",
    name: "sceneCategoryManage",
    meta: {
      title: "场景&类目管理",
      authId: "90612",
      parentId: "906",
      cache: false
    },
    auth: [
      {
        authId: "9061201",
        parentId: "90612",
        label: "关联类目",
        handle: "relationCategory"
      },
      {
        authId: "9061202",
        parentId: "90612",
        label: "新增一级类目",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "addCategory"
      },
      {
        authId: "9061203",
        parentId: "90612",
        label: "编辑",
        handle: "editCategory"
      },
      {
        authId: "9061204",
        parentId: "90612",
        label: "删除",
        handle: "deleteCategory"
      },
      {
        authId: "9061205",
        parentId: "90612",
        label: "添加子类目",
        handle: "addChildCategory"
      }
    ],
    component: _import("systemConfig/sceneCategoryManage/index")
  },
  90613: {
    path: "/merchantCheck",
    name: "merchantCheck",
    meta: {
      title: "对账",
      authId: "90613",
      parentId: "90603",
      cache: false,
      activePath: "/merchantManage"
    },
    component: _import("systemConfig/merchant/merchantStep/merchantCheck")
  },
  90614: {
    path: "/merchantCheckDetail",
    name: "merchantCheckDetail",
    meta: {
      title: "查看详情页面",
      authId: "90614",
      parentId: "90603",
      cache: false,
      activePath: "/merchantManage"
    },
    component: _import("systemConfig/merchant/merchantStep/merchantCheckDetail")
  },
  90615: {
    path: "/merchantCheckRecord",
    name: "merchantCheckRecord",
    meta: {
      title: "历史记录",
      authId: "90615",
      parentId: "90603",
      cache: false,
      activePath: "/merchantManage"
    },
    component: _import("systemConfig/merchant/merchantStep/merchantCheckRecord")
  },
  90616: {
    path: "/costCategoryManage",
    name: "costCategoryManage",
    meta: {
      title: "费用类目管理",
      authId: "90616",
      parentId: "906",
      cache: false
    },
    auth: [
      {
        authId: "9061601",
        parentId: "90616",
        label: "添加",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "addLedgerCategory",
        addRoutePath: [
          {
            authId: "9061607",
            name: "编辑费用类目",
            parentId: "90616"
          }
        ]
      },
      {
        authId: "9061602",
        parentId: "90616",
        label: "编辑",
        handle: "editLedgerCategory"
      },
      {
        authId: "9061603",
        parentId: "90616",
        label: "删除",
        handle: "delLedgerCategory"
      },
      {
        authId: "9061604",
        parentId: "90616",
        label: "添加",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "addReconciliationCategory",
        addRoutePath: [
          {
            authId: "9061608",
            name: "编辑对账类目",
            parentId: "90616"
          }
        ]
      },
      {
        authId: "9061605",
        parentId: "90616",
        label: "编辑",
        handle: "editReconciliationCategory"
      },
      {
        authId: "9061606",
        parentId: "90616",
        label: "删除",
        handle: "delReconciliationCategory"
      }
    ],
    component: _import("systemConfig/costCategoryManage/index")
  },
  9061607: {
    path: "/editLedger",
    name: "editLedger",
    meta: {
      title: "编辑费用类目",
      authId: "9061607",
      parentId: "90616",
      cache: false,
      sideHidden: false,
      activePath: "/costCategoryManage"
    },
    component: _import("systemConfig/costCategoryManage/editLedger")
  },
  9061608: {
    path: "/editReconciliation",
    name: "editReconciliation",
    meta: {
      title: "编辑对账类目",
      authId: "9061608",
      parentId: "90616",
      cache: false,
      sideHidden: false,
      activePath: "/costCategoryManage"
    },
    component: _import("systemConfig/costCategoryManage/editReconciliation")
  },
  90617: {
    path: "/deviceManage",
    name: "deviceManage",
    meta: {
      title: "设备管理",
      authId: "90617",
      parentId: "906",
      cache: false
    },
    auth: [
      {
        authId: "9061701",
        parentId: "90617",
        label: "添加",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "handleAdd",
        addRoutePath: [
          {
            authId: "9061705",
            name: "编辑设备",
            parentId: "90617"
          }
        ]
      },
      {
        authId: "9061702",
        parentId: "90617",
        label: "编辑",
        handle: "handleEdit"
      },
      {
        authId: "9061703",
        parentId: "90617",
        label: "历史记录",
        handle: "handleHistory",
        addRoutePath: [
          {
            authId: "9061706",
            name: "历史记录",
            parentId: "90617"
          }
        ]
      },
      {
        authId: "9061704",
        parentId: "90617",
        label: "删除",
        handle: "handleDelete"
      }
    ],
    component: _import("systemConfig/deviceManage/deviceList")
  },
  9061705: {
    path: "/editDevice",
    name: "editDevice",
    meta: {
      title: "编辑对账类目",
      authId: "9061705",
      parentId: "90617",
      cache: false,
      sideHidden: false,
      activePath: "/deviceManage"
    },
    component: _import("systemConfig/deviceManage/editDevice")
  },
  9061706: {
    path: "/deviceHistory",
    name: "deviceHistory",
    meta: {
      title: "历史记录",
      authId: "9061706",
      parentId: "90617",
      cache: false,
      sideHidden: false,
      activePath: "/deviceManage"
    },
    component: _import("systemConfig/deviceManage/deviceHistory")
  },
  90618: {
    path: "/openshopProcess",
    name: "openshopProcess",
    meta: {
      title: "开店审核",
      authId: "90618",
      parentId: "906",
      cache: false
    },
    auth: [
      {
        authId: "9061801",
        parentId: "90618",
        label: "审核",
        ruleObj: {
          attr: "reviewStatus",
          rule: {
            1: "审核"
          }
        },
        handle: "handleCheck"
      },
      {
        authId: "9061802",
        parentId: "90618",
        label: "驳回",
        ruleObj: {
          attr: "reviewStatus",
          rule: {
            1: "驳回"
          }
        },
        handle: "handleReject"
      }
    ],
    component: _import("systemConfig/OpenshopProcess/index")
  },
  90619: {
    path: "/shopConfig",
    name: "shopConfig",
    meta: {
      title: "店面配置",
      authId: "90619",
      parentId: "906",
      cache: false
    },
    auth: [
      {
        authId: "9061901",
        parentId: "90619",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9061902",
        parentId: "90619",
        label: "导入更新",
        category: "Button",
        type: "primary",
        handle: "handleImport"
      },
      {
        authId: "9061903",
        parentId: "90619",
        label: "收款码",
        handle: "collectionQRcode"
      },
      {
        authId: "9061904",
        parentId: "90619",
        label: "工单设置",
        handle: "handleSet",
        addRoutePath: [
          {
            authId: "9061905",
            name: "工单设置页面",
            parentId: "90619"
          }
        ]
      },
      {
        authId: "9061906",
        parentId: "90619",
        label: "店铺设置",
        handle: "handleShopSet",
        addRoutePath: [
          {
            authId: "9061907",
            name: "店铺设置页面",
            parentId: "90619"
          }
        ]
      },
      {
        authId: "9061908",
        parentId: "90619",
        label: "人员管理",
        handle: "handlePersonnelManage",
        addRoutePath: [
          {
            authId: "9061909",
            name: "人员管理页面",
            parentId: "90619"
          }
        ]
      },
      {
        authId: "9061910",
        parentId: "90619",
        label: "门店标签",
        handle: "handleShopLabelFlag"
      },
      {
        authId: "9061911",
        parentId: "90619",
        label: "导出标签",
        category: "Button",
        type: "primary",
        handle: "handleExportLabel"
      },
      {
        authId: "9061912",
        parentId: "90619",
        label: "员工注册码",
        handle: "employeeRegistrationCode"
      },
      {
        authId: "9061913",
        parentId: "90619",
        label: "积分归属",
        handle: "setPointsAttribution"
      },
      {
        authId: "9061914",
        parentId: "90619",
        label: "阳光激励配置",
        handle: "markRefundHandle"
      }
    ],
    component: _import("systemConfig/ShopConfig/index")
  },
  9061905: {
    path: "/setWorkorderDetail",
    name: "setWorkorderDetail",
    meta: {
      title: "工单设置",
      authId: "9061905",
      parentId: "90619",
      cache: false,
      activePath: "/shopConfig"
    },
    component: _import("systemConfig/ShopConfig/setWorkorderDetail")
  },
  9061907: {
    path: "/shopSet",
    name: "shopSet",
    meta: {
      title: "店铺设置",
      authId: "9061907",
      parentId: "90619",
      cache: false,
      activePath: "/shopConfig"
    },
    component: _import("systemConfig/ShopConfig/shopSet")
  },
  9061909: {
    path: "/personnelManagementIndex",
    name: "personnelManagementIndex",
    meta: {
      title: "人员管理",
      authId: "9061909",
      parentId: "90619",
      cache: false,
      activePath: "/shopConfig"
    },
    component: _import("systemConfig/ShopConfig/personnelManagementIndex")
  },
  // 90620: {
  //   path: "/codeTest",
  //   name: "codeTest",
  //   meta: {
  //     title: "错误码测试页",
  //     authId: "90620",
  //     parentId: "906",
  //     cache: false
  //   },
  //   component: _import("system/codeTest/index")
  // },
  // 90621: {
  //   path: "/staffManage",
  //   name: "staffManage",
  //   meta: {
  //     title: "驻店工资绩效",
  //     authId: "90621",
  //     parentId: "906",
  //     cache: false
  //   },
  //   auth: [
  //     {
  //       authId: "9062101",
  //       parentId: "90621",
  //       label: "导出工资绩效",
  //       category: "Button",
  //       type: "primary",
  //       handle: "handleExport"
  //     },
  //     {
  //       authId: "9062102",
  //       parentId: "90621",
  //       label: "导入员工",
  //       category: "Button",
  //       handle: "handleImport"
  //     },
  //     {
  //       authId: "9062103",
  //       parentId: "90621",
  //       label: "绩效配置",
  //       handle: "handlePerformance",
  //       addRoutePath: [
  //         {
  //           authId: "90622",
  //           name: "绩效配置",
  //           parentId: "90621"
  //         }
  //       ]
  //     },
  //     {
  //       authId: "9062104",
  //       parentId: "90621",
  //       label: "导师配置",
  //       handle: "handleMentor",
  //       addRoutePath: [
  //         {
  //           authId: "90623",
  //           name: "导师配置",
  //           parentId: "90621"
  //         }
  //       ]
  //     },
  //     {
  //       authId: "9062105",
  //       parentId: "90621",
  //       label: "启用工资绩效",
  //       handle: "handleEnableOrDisable",
  //       ruleObj: {
  //         attr: "performanceFlag",
  //         rule: {
  //           N: "启用工资绩效",
  //           Y: "禁用工资绩效"
  //         }
  //       }
  //     },
  //     {
  //       authId: "9062106",
  //       parentId: "90621",
  //       label: "业绩详情",
  //       handle: "handleDetail"
  //     }
  //   ],
  //   component: _import("systemConfig/businessSchoolManage/index")
  // },
  // 90622: {
  //   path: "/performanceConfig",
  //   name: "performanceConfig",
  //   meta: {
  //     title: "绩效配置",
  //     authId: "90622",
  //     parentId: "90621",
  //     sideHidden: true,
  //     activePath: "/staffManage"
  //   },
  //   component: _import("systemConfig/businessSchoolManage/performanceConfig")
  // },
  // 90623: {
  //   path: "/mentorConfig",
  //   name: "mentorConfig",
  //   meta: {
  //     title: "导师配置",
  //     authId: "90623",
  //     parentId: "90621",
  //     sideHidden: true,
  //     activePath: "/staffManage"
  //   },
  //   component: _import("systemConfig/businessSchoolManage/mentorConfig")
  // },
  90624: {
    path: "/ruleReview",
    name: "ruleReview",
    meta: {
      title: "规则审核",
      authId: "90624",
      parentId: "906",
      cache: false
    },
    auth: [
      {
        authId: "9062401",
        parentId: "90624",
        label: "审核",
        handle: "handleReview",
        addRoutePath: [
          {
            authId: "9062404",
            name: "审核",
            parentId: "90624"
          }
        ]
      },
      {
        authId: "9062402",
        parentId: "90624",
        label: "驳回",
        handle: "handleReject"
      },
      {
        authId: "9062403",
        parentId: "90624",
        label: "撤销",
        handle: "handleRevoke"
      }
    ],
    component: _import("systemConfig/ruleReview/index")
  },
  9062404: {
    path: "/examineDetail",
    name: "examineDetail",
    meta: {
      title: "审核",
      authId: "9062404",
      parentId: "90624",
      cache: false,
      sideHidden: false,
      activePath: "/ruleReview"
    },
    component: _import("systemConfig/ruleReview/examineDetail")
  },
  // 90625: {
  //   path: "/inStoreGoalsConfig",
  //   name: "inStoreGoalsConfig",
  //   meta: {
  //     title: "驻店目标配置",
  //     authId: "90625",
  //     parentId: "906",
  //     cache: false
  //   },
  //   auth: [
  //     {
  //       authId: "9062501",
  //       parentId: "90625",
  //       label: "新增",
  //       category: "Button",
  //       type: "primary",
  //       handle: "handleAdd",
  //       addRoutePath: [
  //         {
  //           authId: "90626",
  //           name: "新增",
  //           parentId: "90625"
  //         }
  //       ]
  //     },
  //     {
  //       authId: "9062502",
  //       parentId: "90625",
  //       label: "查看",
  //       handle: "handleStoreView",
  //       addRoutePath: [
  //         {
  //           authId: "90627",
  //           name: "查看",
  //           parentId: "90625"
  //         }
  //       ]
  //     },
  //     {
  //       authId: "9062503",
  //       parentId: "90625",
  //       label: "编辑",
  //       handle: "handleStoreEdit",
  //       addRoutePath: [
  //         {
  //           authId: "90626",
  //           name: "编辑",
  //           parentId: "90625"
  //         }
  //       ]
  //     },
  //     {
  //       authId: "9062504",
  //       parentId: "90625",
  //       label: "导出",
  //       category: "Button",
  //       type: "primary",
  //       handle: "handleExport"
  //     },
  //     {
  //       authId: "9062505",
  //       parentId: "90625",
  //       label: "查看",
  //       handle: "handleStaffView",
  //       addRoutePath: [
  //         {
  //           authId: "90628",
  //           name: "查看任务",
  //           parentId: "90625"
  //         }
  //       ]
  //     }
  //   ],
  //   component: _import("systemConfig/inStoreGoalsConfig/index")
  // },
  // 90626: {
  //   path: "/addInStoreConfig",
  //   name: "addInStoreConfig",
  //   meta: {
  //     title: "新增",
  //     authId: "90626",
  //     parentId: "90625",
  //     sideHidden: true,
  //     activePath: "/inStoreGoalsConfig"
  //   },
  //   component: _import("systemConfig/inStoreGoalsConfig/addInStoreConfig")
  // },
  // // 查看店面目标配置
  // 90627: {
  //   path: "/inStoreConfigView",
  //   name: "inStoreConfigView",
  //   meta: {
  //     title: "查看",
  //     authId: "90627",
  //     parentId: "90625",
  //     sideHidden: true,
  //     activePath: "/inStoreGoalsConfig"
  //   },
  //   component: _import("systemConfig/inStoreGoalsConfig/addInStoreConfig")
  // },
  // // 查看驻店员工任务
  // 90628: {
  //   path: "/employeeTasksView",
  //   name: "employeeTasksView",
  //   meta: {
  //     title: "查看任务",
  //     authId: "90628",
  //     parentId: "90625",
  //     sideHidden: true,
  //     activePath: "/inStoreGoalsConfig"
  //   },
  //   component: _import("systemConfig/inStoreGoalsConfig/employeeTasksView")
  // },
  // 90629: {
  //   path: "/inStoreManage",
  //   name: "inStoreManage",
  //   meta: {
  //     title: "驻店管理",
  //     authId: "90629",
  //     parentId: "906",
  //     cache: false
  //   },
  //   auth: [
  //     {
  //       authId: "9062901",
  //       parentId: "90629",
  //       label: "查看标签",
  //       handle: "handleViewLabel"
  //     }
  //   ],
  //   component: _import("systemConfig/inStoreManage/index")
  // },
  90630: {
    path: "/downloadReportManage",
    name: "downloadReportManage",
    meta: {
      title: "下载报表",
      authId: "90630",
      parentId: "906",
      cache: false
    },
    auth: [
      {
        authId: "9063001",
        parentId: "90630",
        label: "下载",
        handle: "handleDownload"
      },
      {
        authId: "9063002",
        parentId: "90630",
        label: "重新生成",
        handle: "handleGenerate"
      }
    ],
    component: _import("systemConfig/downloadReportManage/index")
  }
}
